import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpLoaderFactory } from '../../services/httpLoaderFactory';
import { PleaseWaitComponent } from './please-wait/please-wait.component';
import { FocusMeDirective } from './shared/focus-me.directive';
import { PrivilegesDirective } from './shared/privileges.directive';
import { StopPropagationDirective } from './shared/stop-propagation.directive';
import { TitlePipe } from './shared/title.pipe';
import { TruncatePipe } from './shared/truncate.pipe';
import { LimitPipe } from './shared/limit.pipe';
import { ContainsPipe } from './shared/contains.pipe';
import { NotContainsPipe } from './shared/not-contains.pipe';
import { NoPrivilegesDirective } from './shared/no-privileges.directive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MarkPipe } from './shared/mark.pipe';
import { HslPipe } from './shared/hsl.pipe';
import { AccessabilityModule } from './accessability/accessability.module';
import { DragDirective } from './shared/drag.directive';
import { ForDisplayPipe } from './shared/for-display.pipe';
import { CustomerTranslatePipe } from './shared/customer-translate.pipe';
import { CustomerDatePipe } from './shared/customer-date.pipe';
import { CustomerDateTimePipe } from './shared/customer-date-time.pipe';
import { HierarchyDirective } from './shared/hierarchy.directive';
import { ToggleGroupDirective } from './shared/toggle-group.directive';
import { ToggleDirective } from './shared/toggle.directive';
import { StartsWithPipe } from './shared/starts-with.pipe';
import { AccessibleTooltipDirective } from './shared/accessible-tooltip.directive';

@NgModule({
  declarations: [
    PrivilegesDirective,
    NoPrivilegesDirective,
    FocusMeDirective,
    TitlePipe,
    PleaseWaitComponent,
    StopPropagationDirective,
    TruncatePipe,
    LimitPipe,
    StopPropagationDirective,
    ContainsPipe,
    NotContainsPipe,
    MarkPipe,
    HslPipe,
    DragDirective,
    ForDisplayPipe,
    CustomerTranslatePipe,
    CustomerDatePipe,
    CustomerDateTimePipe,
    HierarchyDirective,
    ToggleGroupDirective,
    ToggleDirective,
    StartsWithPipe,
    AccessibleTooltipDirective
  ],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    CommonModule,
    TooltipModule.forRoot(),
    AccessabilityModule

  ],
  exports: [
    PrivilegesDirective,
    NoPrivilegesDirective,
    FocusMeDirective,
    TitlePipe,
    TruncatePipe,
    PleaseWaitComponent,
    StopPropagationDirective,
    TranslateModule,
    FormsModule,
    CommonModule,
    LimitPipe,
    ContainsPipe,
    NotContainsPipe,
    TooltipModule,
    MarkPipe,
    HslPipe,
    AccessabilityModule,
    DragDirective,
    ForDisplayPipe,
    CustomerTranslatePipe,
    CustomerDateTimePipe,
    CustomerDatePipe,
    HierarchyDirective,
    ToggleDirective,
    ToggleGroupDirective,
    StartsWithPipe,
    AccessibleTooltipDirective
  ]
})
export class SharedModule {}
